import { render, staticRenderFns } from "./HomePage.fr.vue?vue&type=template&id=fc55e76a&"
import script from "./HomePage.fr.vue?vue&type=script&lang=ts&"
export * from "./HomePage.fr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports